import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CityClient, CityView, SearchCityParameters } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class CityService {
    constructor(private readonly client: CityClient) {}

    async search(body: SearchCityParameters): Promise<CityView[]> {
        return await lastValueFrom(this.client.citySearch(body));
    }

    async getById(id: number): Promise<CityView> {
        return await lastValueFrom(this.client.cityGetById(id));
    }
}
